export default {
    isValidAddress(address) {
        const solRegex = /^[1-9A-HJ-NP-Za-km-z]{40,48}$/;
        return address.search(solRegex) !== -1;
    },
};
